import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 导入翻译文件
import zh from './locales/zh.json';
import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

const resources = {
	zh: {
		translation: zh,
	},
	en: {
		translation: en,
	},
	es: {
		translation: es,
	},
	pt: {
		translation: pt,
	},
};

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		lng: 'es', // 默认语言
		fallbackLng: 'es',
		debug: false,

		interpolation: {
			escapeValue: false, // React已经处理了XSS
		},

		detection: {
			order: ['localStorage', 'navigator', 'htmlTag'],
			caches: ['localStorage'],
		},
	});

export default i18n;
